import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import compose from 'recompose/compose';
import { Field, Form, reduxForm } from 'redux-form';
import { propBool, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import { validateBoardName } from '../../../../validate/client_my_page';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import { StandardField } from '../../../Ui/FormFields';
const FormCreateBoard = (props) => {
    const { error, handleSubmit, submitting } = props;
    return (_jsx("div", Object.assign({ className: 'modal-content create-board-modal' }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit }, { children: [_jsx("div", Object.assign({ className: 'modal-header' }, { children: _jsx("h3", Object.assign({ className: 'board-title' }, { children: "\u65B0\u3057\u3044\u30DC\u30FC\u30C9\u3092\u4F5C\u6210" })) })), _jsx("div", Object.assign({ className: 'create-board-modal-body' }, { children: _jsxs("label", Object.assign({ className: 'board-form-box' }, { children: [_jsx("div", Object.assign({ className: 'label' }, { children: "\u30DC\u30FC\u30C9\u306E\u540D\u524D" })), _jsx(Field, { component: StandardField, name: 'name', placeholder: '', type: 'text', validate: validateBoardName })] })) })), _jsx("div", Object.assign({ className: 'board-button-row' }, { children: _jsx(SubmitButton, { buttonType: 'submit', isDisabled: !!(error || submitting), isLoading: !!submitting, text: '保存する' }) }))] })) })));
};
FormCreateBoard.propTypes = {
    error: propStr(),
    handleSubmit: propFunc().isRequired,
    submitting: propBool().isRequired,
};
FormCreateBoard.defaultProps = {
    error: '',
};
const enhance = compose(reduxForm({ form: 'FormCreateBoard' }));
export default enhance(FormCreateBoard);
